import React from 'react'
import ReactMarkdown from 'react-markdown'

import { ActionStrip, Button } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'

import {
  CryptoInterstitalProps,
  STRING_PREFIX,
  ValueProp,
} from './CryptoInterstitial'
import {
  Body,
  BodyHeader,
  Container,
  Content,
  MarkdownStyler,
  StyledLogo,
  TextContainer,
  Title,
  ValuePropContainer,
} from './styled-components'

export const CryptoLanderDesktop: React.FC<CryptoInterstitalProps> = ({
  onBack,
  cta,
  header1,
  header2,
  icons,
  imageUrl,
  title,
  toggleModal,
  value_prop1,
  value_prop2,
  value_prop3,
  action_strip_title,
  ...props
}) => {
  const { StyledRemoteString } = useRemoteStrings()

  return (
    <>
      <ActionStrip
        verticalSubText
        maxWidth={800}
        title={action_strip_title}
        onBack={onBack}
      />
      <Container>
        <Content>
          <StyledLogo src={imageUrl} />
          <TextContainer>
            <Title>{title}</Title>
            <ValuePropContainer>
              {[value_prop1, value_prop2, value_prop3].map((prop, index) => (
                <ValueProp
                  iconName={icons[index]}
                  copy={prop}
                  key={`${prop}${index}`}
                />
              ))}
            </ValuePropContainer>
            <Button
              onPress={() => props.onAddPortfolioPress(toggleModal)}
              secondary
              className={'add-portfolio-button'}
            >
              {cta}
            </Button>
            <BodyHeader>{header1}</BodyHeader>
            <Body>
              <StyledRemoteString
                stringKey={`${STRING_PREFIX}body1`}
                modifiers={[{ bold: 600 }]}
              />
            </Body>
            <BodyHeader>{header2}</BodyHeader>
            <Body>
              <StyledRemoteString
                stringKey={`${STRING_PREFIX}body2.markdown`}
                modifiers={[
                  { bold: 600 },
                  { bold: 600 },
                  { bold: 600 },
                  { bold: 600 },
                  { bold: 600 },
                ]}
                wrappers={[
                  { component: MarkdownStyler },
                  { component: MarkdownStyler },
                  { component: MarkdownStyler },
                  { component: MarkdownStyler },
                  { component: MarkdownStyler },
                ]}
              />
              <ReactMarkdown
                source={props['disclosure.link.markdown']}
                linkTarget={'_blank'}
                className="disclosure-markdown"
                escapeHtml={false}
              />
            </Body>
          </TextContainer>
        </Content>
      </Container>
    </>
  )
}
